/* columnSizer.js - Resizes table columns according to parent container width */
/* Base requirement is to set the valign attribute to "top" on each <td> in the table. */
/* Then you mark up the table with classes for each td, or use csColumnName attribute. */

import { logger } from '@/util/logger';

var $ = window.$;
window.add = function(arr) {
	return arr.reduce(function(a, b) { return a + b; });
};

window.arrCSColumns = [];
window.arrCSMidSizes = [];
window.arrCSMinSizes = [];
window.arrCSMaxSizes = [];
window.arrCSHideable = [];
window.arrCSNoWrap = [];
window.arrCSSetSizes = [];
window.arrCSTableIDs = [];
window.intUsableWidthPixelsToAdd = 0;
window.booUseAttributes = false;
window.strSelectorStart = '.';
window.strSelectorEnd = '';

//var intPreviousWindowWidthColumnSizer = 0;
//var intPreviousWindowWidthColumnSizeCount = 0;


// CER-4560 Modular version to support multiple instances on a single page
window.ColumnSizerTable = function(id, extraPixelsColumn) {
	this.id = id;
	const _$table = $(`#${this.id}`);
	
    function _Column(name, mid, min, max, booHideable, booNoWrap, booFixed) {
        return {
            name: name,
            mid: mid,
            min: min, 
			max: max,
			current: 0,
            hideable: booHideable,
			noWrap: booNoWrap,
			fixed: booFixed,
			isHidden: false
		}
	}
	function _getTable() {
		if (_$table.length) return _$table
		return $(`#${this.id}`);
	}

	function _getWidthAllocation(usableWidth, totalMid, col) {
		const ratio = col.mid / totalMid;
		return Math.round(usableWidth * ratio);

	}
	function _showColumn (col) {
		$(`.${col.name}`).css({
			'overflow': 'hidden',
			'width': col.current + 'px',
			'white-space': col.noWrap ? 'nowrap' : 'wrap',
			'position': '',
			'top': '',
			'visibility': 'visible'
		});
	};
	function _hideColumn(col) {
		$(`.${col.name}`).css({
			'width': 0,
			'position': 'absolute',
			'top': -999999,
			'visibility': 'hidden'
		});
	};
	this.columns = [];

    this.loadColumn = function(strColumnName, intMidSize, intMinSize, intMaxSize, booHideable, booNoWrap, booFixed) {
		const col = new _Column(strColumnName, intMidSize, intMinSize, intMaxSize, booHideable, booNoWrap, booFixed)
		this.columns.push(col);
    };

	this.doColumnSizing = function() {
		const $table = _getTable.call(this);

		if (!$table.length) {
			return;
		}

		if (!this.columns.length) {
			return;
		}

		if ($table.offset() == undefined) {
			return;
		}

		let columnsPresent = this.columns.filter(col => $(`.${col.name}`).length);
		const intTotalMidSizes = columnsPresent.map(col => col.mid).reduce((a,b) => a + b, 0);

		let intUsableWidth = window.getUsableWidth();
		let intRemainingPixels = intUsableWidth;
		var intWidth = 0;
	
		$table.css({
			'table-layout': 'fixed'
		});
	
		//make a first pass to do a simple distribution of pixels among columns.
		intRemainingPixels = intUsableWidth;
		columnsPresent.forEach((col) => {
			col.isHidden = false;
			intWidth = _getWidthAllocation(intUsableWidth, intTotalMidSizes, col)
			if (intWidth < col.min) {
				if (col.hideable) {
					intWidth = 0;
					col.isHidden = true
				} else {
					intWidth = col.min;
				}
			} else if (intWidth > col.max) {
				intWidth = col.max
			}
			col.current = intWidth;
			intRemainingPixels -= intWidth;
		});
	

		// distribute remaining pixels
		if (intRemainingPixels > 0) {
			const adjustableColumns = columnsPresent.filter(col => !col.isHidden && col.current < col.max);
			intUsableWidth = intRemainingPixels;
			adjustableColumns.forEach((col) => {
				// get preferred width allocation, capped at max width
				intWidth = Math.min(col.max, col.current + _getWidthAllocation(intUsableWidth, intTotalMidSizes, col));
				col.current = intWidth;

				// calculate adjustment to subtract from remaining pixels total
				const intAdjustment = intWidth - col.current;
				logger.log(col.name, intAdjustment)
				intRemainingPixels -= intAdjustment
			});
		}

		if (intRemainingPixels > 0) {

			if (typeof extraPixelsColumn !== 'undefined') {
				// give any remaining width to the "extra pixels" column
				this.columns.find(col => col.name === extraPixelsColumn).current += intRemainingPixels;
			} else {
				// otherwise spread evenly between all visible columns
				const visibleColumns = columnsPresent.filter(col => !col.isHidden && !col.fixed);
				const len = visibleColumns.length;
				visibleColumns.forEach(col => {
					col.current += window.Math.floor(intRemainingPixels / len)
				})
			}
		}
		
		// subtract 10 pixels to account for cellspacing and cellpadding of each column that is showing.
		const intSubtract = 10;
		columnsPresent.forEach(function(col){
			if (col.isHidden) {
				_hideColumn(col)
			} else {
				col.current -= intSubtract;
				_showColumn(col);
			}
		})
	}

	window.layoutQueue.add('doColumnSizing', this);

}


window.loadColumn = function(intIndex, strColumnName, intMidSize, intMinSize, intMaxSize, booHideable, booNoWrap, strTableID) {
    window.arrCSColumns[intIndex] = strColumnName;
	window.arrCSMidSizes[intIndex] = intMidSize;
	window.arrCSMinSizes[intIndex] = intMinSize;
	window.arrCSMaxSizes[intIndex] = intMaxSize;
	window.arrCSHideable[intIndex] = booHideable;
	if (booNoWrap) {
		window.arrCSNoWrap[intIndex] = 'nowrap';
	}
	else {
		window.arrCSNoWrap[intIndex] = 'normal';
	}
	window.arrCSTableIDs[intIndex] = strTableID;
};

// not available in modular version
window.setUsableWidthAdjustment = function(intPixelsToAdd) {
	window.intUsableWidthPixelsToAdd = intPixelsToAdd;
};

// not available in modular version
window.setUseAttributes = function(booUse) {
	window.booUseAttributes = booUse;
	if (window.booUseAttributes) {
		window.strSelectorStart = 'td[cscolumnname=\'';
		window.strSelectorEnd = '\']';
	}
};

window.totalWidth = 0;

window.setColumnSize = function(intIndex, intSize) {
	window.totalWidth = window.totalWidth + intSize;
	$(window.strSelectorStart + window.arrCSColumns[intIndex] + window.strSelectorEnd).css({
		'overflow': 'hidden',
		'white-space': window.arrCSNoWrap[intIndex],
		'width': intSize,
		'position': '',
		'top': '',
		'visibility': 'visible'
	});

};

window.hideColumn = function(intIndex) {
	$(window.strSelectorStart + window.arrCSColumns[intIndex] + window.strSelectorEnd).css({
		'overflow': 'hidden',
		'white-space': window.arrCSNoWrap[intIndex],
		'width': 0,
		//'height':0,
		'position': 'absolute',
		'top': -999999,
		'visibility': 'hidden'
	});
};

window.doColumnSizingKicker = function() {
	window.doColumnSizing();
};

window.getUsableWidth = function(){
    const hasEmbarkSideNav = $('.has-embark-header').length;
    const hasCardWrapper = document.getElementById('MainContent_ExpensesTextPanel')?.classList.contains('js-columnsizer-card');
    const BASE_OFFSET = hasCardWrapper ? 65 : 40; // accounts for padding around card and container
    if (hasEmbarkSideNav) {
        const containerWidth = window.getContainerWidth();
        const docWidth = document.documentElement.clientWidth;
        const sideNavOffset = $('#sidenav_offset').width() || 0;
        return Math.min(containerWidth, docWidth - sideNavOffset) - BASE_OFFSET;
    } else {
        return $('.js-head').width() - BASE_OFFSET;
    }
}

window.doColumnSizing = function() {
	window.totalWidth = 0;

	if (window.arrCSColumns.length == 0) {
		return;
	}

	var intValue = 0;
	var intTotalMidSizes = 0;
	var objTable = $('#' + window.arrCSTableIDs[0]);
	var intUsableWidth = 0;
	var intRemainingPixels = 0;
	var arrColumnsPresent = [];

	if ($(objTable).offset() == undefined) {
		return;
	}

	var i = 0;
	$(objTable).css({
		'table-layout': 'fixed'
	});


    intUsableWidth = window.getUsableWidth();
    
    
    for (i = 0; i < window.arrCSColumns.length; i++) {
		if ($(window.strSelectorStart + window.arrCSColumns[i] + window.strSelectorEnd).length > 0) {
			intTotalMidSizes = intTotalMidSizes + window.arrCSMidSizes[i];
			arrColumnsPresent[window.arrCSColumns[i]] = '1';
		}
	}

	//make a first pass to do a simple distribution of pixels among columns.
	intRemainingPixels = intUsableWidth;

	for (i = 0; i < window.arrCSColumns.length; i++) {
		if (arrColumnsPresent[window.arrCSColumns[i]] == '1') {
			intValue = Math.round(intUsableWidth * (window.arrCSMidSizes[i] / intTotalMidSizes));
			if (intValue < window.arrCSMinSizes[i]) {
				if (window.arrCSHideable[i] == true) {
					intValue = 0;
				}
				else {
					intValue = window.arrCSMinSizes[i];
				}
			}
			else if (intValue > window.arrCSMaxSizes[i]) {
				intValue = window.arrCSMaxSizes[i];
			}
			window.arrCSSetSizes[i] = intValue;
			intRemainingPixels = intRemainingPixels - intValue;
		}
	}

	// make a second pass to redistribute unused pixels among columns that are visible and not at max size.
	if (intRemainingPixels > 0) {
		for (var x = 0; x < 10; x++) {
			intUsableWidth = intRemainingPixels;
			for (i = 0; i < window.arrCSColumns.length; i++) {
				if (arrColumnsPresent[window.arrCSColumns[i]] == '1') {
					if (window.arrCSSetSizes[i] == 0 && window.arrCSHideable[i] === true) {
						// column is hidden, so do not redistribute any pixels to it.
					}
					else if (window.arrCSSetSizes[i] >= window.arrCSMaxSizes[i]) {
						// column is alread at max size, so do not redistribute any pixels to it.
					}
					else {
						intValue = Math.round(intUsableWidth * (window.arrCSMidSizes[i] / intTotalMidSizes));
						if (intValue == 0) {
							x = 10;
						}
						if (window.arrCSSetSizes[i] + intValue >= window.arrCSMaxSizes[i]) {
							intValue = 0;
						}
						window.arrCSSetSizes[i] = window.arrCSSetSizes[i] + intValue;
						intRemainingPixels = intRemainingPixels - intValue;
					}
				}
			}
			if (intRemainingPixels == 0) {
				x = 10;
			}
		}
	}

	//make a final pass through and subtract pixels to account for cellspacing and cellpadding of each column that is showing.

	var intSubtract = 10;

	for (i = 0; i < window.arrCSColumns.length; i++) {
		
		if (window.arrCSSetSizes[i] > 0) {
			window.arrCSSetSizes[i] = window.arrCSSetSizes[i] - intSubtract;
		}
	}



	for (i = 0; i < window.arrCSColumns.length; i++) {
		if (arrColumnsPresent[window.arrCSColumns[i]] == '1') {
			if (window.arrCSSetSizes[i] == 0) {
				window.hideColumn(i);
			}
			else {
				window.setColumnSize(i, window.arrCSSetSizes[i]);
			}
		}
	}

	if (typeof afterDoColumnSizing == 'function') {
		window.afterDoColumnSizing();
	}
};